import { Link, useLocation } from 'react-router-dom';
import { Home, Building2, Bot, Menu } from 'lucide-react';

function MobileBottomNav() {
  const location = useLocation();

  const navItems = [
    { icon: <Home className="h-5 w-5" />, label: "Home", path: "/" },
    { icon: <Building2 className="h-5 w-5" />, label: "Directory", path: "/businesses" },
    { icon: <Bot className="h-5 w-5" />, label: "AI Chat", path: "/ai-assistant" },
    { icon: <Menu className="h-5 w-5" />, label: "More", path: "/services" }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Spacer to prevent content being hidden behind nav */}
      <div className="md:hidden h-16" />
      
      {/* Bottom Navigation Bar - Mobile Only */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-[9999] pb-safe">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item, index) => (
            <Link
              key={`item-${index}`}
              to={item.path}
              className={`flex flex-col items-center justify-center px-4 py-2 transition-colors relative ${
                isActive(item.path)
                  ? 'text-[#006847]'
                  : 'text-gray-500 active:text-[#006847]'
              }`}
            >
              {item.icon}
              <span className="text-xs mt-1">{item.label}</span>
              {isActive(item.path) && (
                <span className="absolute bottom-0 w-8 h-0.5 bg-[#006847] rounded-full" />
              )}
            </Link>
          ))}
        </div>
      </nav>
    </>
  );
}

export default MobileBottomNav;
